import React, { useContext } from 'react'
import debounce from "lodash.debounce"
import { GatsbyImage } from "gatsby-plugin-image"
import { getShopifyImage } from "gatsby-source-shopify"

import { StoreContext } from '@context/StoreContext'
import QuickBuyContext from '@context/QuickBuyContext'

//import HeartIcon from '@components/common/HeartIcon'
import SoftButton from '@components/common/SoftButton'
import Tag from '@components/common/Tag'
import { Dot, MinusCircle, PlusCircle, Trash } from '@phosphor-icons/react'
//import SaveToWishList from '@components/common/SaveToWishList'
import {formatPrice} from '@utils'
import { GA_EVENTS } from '@utils/analytics/constants'
import { sendGAEvent } from '@utils/analytics'

const LineItem = ({item}) => {
    const {loading, removeLineItem, updateLineItem} = useContext(StoreContext);
    const {setShowBag} = useContext(QuickBuyContext)
    
    const [quantity, setQuantity] = React.useState(item.quantity)

    const handleNavigate = () => {
        setShowBag(false)
        window.location = `/products/${item?.merchandise?.product?.handle}`;
    }

    
    const subtotal = formatPrice(
        item.cost.totalAmount.currencyCode,
        item.cost.totalAmount.amount
    )
    

    const variantImage = React.useMemo(() => ({
        ...item.merchandise.image,
        originalSrc: item.merchandise.image.originalSrc,
    }), [item.merchandise.image]);
    
    const image = React.useMemo(
        () =>
            getShopifyImage({
                image: variantImage,
                layout: "constrained",
                crop: "contain",
                width: 262,
                height: 390,
            }), 
        [variantImage]
    );

    const title = item?.merchandise?.product?.title?.split(" / ")?.[0];
    const variantName = item?.merchandise?.product?.title?.split(" / ")?.[1]?.replace("FINAL SALE","");
    const isFinalSale = item?.merchandise?.product?.title?.includes("FINAL SALE");


    const handleRemove = async () => {
        const cartData = await removeLineItem(item?.id)
		if(!cartData) return
		// console.log("item to remove:", item)
		const { cost, merchandise } = item
		sendGAEvent(GA_EVENTS.REMOVE_FROM_CART, {
			currency: cost?.subtotalAmount?.currencyCode,
			value: cost?.subtotalAmount?.amount,
			items: [
				{
					item_id: merchandise?.id,
					item_name: merchandise?.product?.title,
					affiliation: "Blackbough Swim",
					// coupon: "SUMMER_FUN",
					discount: parseFloat(cost?.compareAtAmountPerQuantity?.amount) - parseFloat(cost?.subtotalAmount?.amount),
					// index: 0,
					item_brand: "Blackbough Swim",
					item_category: "Apparel",
					item_category2: merchandise?.title,
					// item_category3: "Shirts",
					// item_category4: "Crew",
					// item_category5: "Short sleeve",
					// item_list_id: "related_products",
					// item_list_name: "Related Products",
					item_variant: merchandise?.id,
					// location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
					price: parseFloat(cost?.subtotalAmount?.amount),
					quantity: 1
				},
			]
		})
		// if (cartData) sendAddToCartGAEvent(GA_EVENTS.REMOVE_FROM_CART, item, cartData)
    }

    const uli = debounce((value) => updateLineItem(item.id, value), 300)
    // eslint-disable-next-line
    const debouncedUli = React.useCallback((value) => uli(value), [])

    const handleQuantityChange = (value) => {
        if (value !== "" && Number(value) < 1) {
            return
        }

        setQuantity(value)

        if (Number(value) >= 1) {
            debouncedUli(value)
        }
      }
    
    const doIncrement = () => {
        handleQuantityChange(Number(quantity || 0) + 1);
    }
    
    const doDecrement = () => {
        handleQuantityChange(Number(quantity || 0) - 1);
    }
    
    return (
        <React.Fragment>
            <div className="w-full grid grid-cols-4 max-w-full md:max-w-[343px] gap-x-4 h-full">
                
                <button className="w-20 h-30 col-span-1 cursor-pointer" onClick={() => handleNavigate()}>
                    {image && (
                        <GatsbyImage
                            key={variantImage.src}
                            image={image}
                            alt={variantImage.altText ?? item.merchandise.product.title}
                        />
                    )}
                </button>
                

                <div className="pt-1 flex flex-col col-span-3">
                    <button className="flex flex-nowrap gap-x-2 cursor-pointer text-left" onClick={() => handleNavigate()}><p className="flex-1 font-semibold">{title}</p></button>

                    <div className="flex flex-nowrap items-center text-sm">
                        <p className="text-tertiary">{variantName}</p>
                        <Dot size={20} weight="bold" />
                        <p className="text-tertiary">{item.merchandise.title === "+" ? "Free Size" : item.merchandise.title}</p>
                    </div>
                    
                    {
                        isFinalSale && 
                            <div className="flex gap-2 text-xs font-semibold pt-2">
                                <Tag label={"Final Sale"} className="border border-gray-300" />
                            </div>
                    }
                    

                    <div className="flex flex-nowrap justify-between flex-grow items-end py-4">
                        <div className="grid grid-cols-3 gap-x-2 items-center">
                            {
                                !title.includes("FREE") ? <>
                                    <MinusCircle
                                        size={24}
                                        weight={"light"}
                                        className={`${quantity > 1 ? "cursor-pointer" : "text-gray-300"}`}
                                        onClick={() => doDecrement()}
                                    />
                                    <span className="text-center">{quantity}</span>
                                    <PlusCircle
                                        size={24}
                                        weight={"light"}
                                        className="cursor-pointer"
                                        onClick={() => doIncrement()}
                                    />
                                </> : null
                            }
                            
                        </div>
                        
                        <p className="text-tertiary">{!title.includes("FREE") ? subtotal : "FREE"}</p>
                    </div>
                    
                    {
                        /*
                            showWarning && (
                            <div className="p-2 text-red-600 flex flex-nowrap gap-x-2 text-xs items-start border border-red-600">
                                <WarningCircle size={24} weight="light" />
                                <p>
                                    Sorry, but you can’t add more of this product to the cart.
                                </p>
                            </div>
                            )
                        */
                    }
                </div>
            </div>

            <div className="flex gap-x-3 flex-1 text-[13px] items-center justify-end py-4 border-b border-gray-200">
                {/* <SaveToWishList onClick={() => handleSave()} />
                <div className="text-secondary">|</div> */}

                {!title.includes("FREE") ?
                    <SoftButton
                        label={"REMOVE"}
                        disabled={loading}
                        onClick={() => handleRemove()}
                        iconPosition="start"
                        iconGap="gap-x-2"
                        icon={<Trash size={16} weight="light" />}
                        ariaLabel={'Remove Item'}
                    /> : null
                }
            </div>
        </React.Fragment>
    );
}

export default LineItem;